import { PaymentInstrument } from "../../utils/goPay/PaymentInstrument.js";
import { PaymentType } from "../PaymentType.js";

export const paymentTypeToGoPayPaymentInstrumentMap: Record<PaymentType, PaymentInstrument | null> = {
	[PaymentType.GoPayApplePay]: PaymentInstrument.ApplePay,
	[PaymentType.GoPayGPay]: PaymentInstrument.GPay,
	[PaymentType.GoPayPaymentCard]: PaymentInstrument.PaymentCard,
	[PaymentType.GoPayQRCode]: PaymentInstrument.BankAccount,
	[PaymentType.OnDelivery]: null,
	[PaymentType.OnInvoice]: null,
	[PaymentType.Subscription]: null,
	[PaymentType.WithoutInvoice]: null,
};
